import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CommonMethodService } from "../../Services/CommonMethodService";
import { screens } from "../../modals/Enums/Screens";
import { Mixpanel } from "../../Services/MixPanel";

import AssessmentCard from "../../AssessmentCard/AssessmentCard";
import moment from "moment";
const assessmentSvg = require("../../assets/images/svg/assessment.svg").default;
const inspectionSvg = require("../../assets/images/svg/inspection.svg").default;

export interface IStep {
  handleNext: () => void;
  handleBack?: () => void;
  step: number;
  bookingDate?: string | null;
  repairType?: string;
}

export interface IAssessmentCard {
  id: number;
  title?: string;
  buttonText: string;
  assessmentImage: string;
  description: string;
  recommended?: boolean;
  outlineButton?: boolean;
  date?: string;
  time?: string;
  imageClass?: string;
  isDisabled?: boolean;
}

const StepTwo = ({
  handleNext,
  bookingDate,
  repairType = "Minor",
  handleBack = () => {},
}: IStep) => {
  const params = useParams();
  const navigate = useNavigate();
  const [selectedCardId, setSelectedCardId] = useState<number>(2);
  const [assessmentCards, setAssessmentCards] = useState<IAssessmentCard[]>([]);
  const commonMethodService = new CommonMethodService();

  useEffect(() => {
  
    setAssessmentCards([
      {
        id: 1,
        title: "",
        buttonText: "Digital Assessment",
        assessmentImage: assessmentSvg,
        description: "Send us photos of the damage",
        recommended: false,
        outlineButton: false,
        date: "",
        time: "",
        imageClass: "digital-assessment-icon",
        isDisabled: repairType !== "Minor",
      },
      {
        id: 2,
        title: "Recommended",
        buttonText: "Onsite Inspection",
        assessmentImage: inspectionSvg,
        description: "Drop by the workshop for an onsite assessment",
        recommended: true,
        outlineButton: true,
        date: bookingDate
          ? moment(bookingDate as string).format("ddd, DD MMMM YYYY")
          : "",
        time: bookingDate
          ? `at ${moment(bookingDate as string).format("hh:mm A")}`
          : "",
        imageClass: "assessment-icon",
      },
    ]);
  }, [bookingDate]);

  const handleCardClick = (id: number) => {
    let tempCards = [...assessmentCards];
    tempCards = tempCards.map((card) => {
      if (card.id === id) {
        card.recommended = true;
        setSelectedCardId(id);
      } else {
        card.recommended = false;
      }
      return card;
    });
    setAssessmentCards(tempCards);
  };

  const handleSchedule = () => {
    const id: string = String(params["id"]);
    commonMethodService.removeSingleQueryParams("formStep");
    commonMethodService.setQueryParams(id, screens.bookingInspection);
    const currentParams = CommonMethodService.params();
    Mixpanel.track("Schedule Button Clicked", {
      action: bookingDate ? "Reschedule" : "Schedule",
      selectedCardId: selectedCardId,
      bookingDate: bookingDate || "Not Provided",
      repairType: repairType,
    });
    navigate(
      `/?estimateid=${currentParams["estimateid"]}&step=${currentParams["step"]}`
    );
  };

  const handleNextWithMixpanel = () => {
    Mixpanel.track("Digital Assessment Viewed", {
      selectedCardId: selectedCardId,
      bookingDate: bookingDate || "Not Provided",
      repairType: repairType,
    });

    handleNext();
  };

  return (
    <>
      <div className="assessment-card-container">
        {assessmentCards.map((card: IAssessmentCard, i) => {
          return (
            <AssessmentCard
              key={i}
              card={card}
              handleCardClick={handleCardClick}
            />
          );
        })}
      </div>
      <div className="btn-container">
        <button className="outlined-button" onClick={handleBack}>
          Back
        </button>
        {selectedCardId === 1 ? (
          <button onClick={handleNextWithMixpanel} className="button-dark">
            Next
          </button>
        ) : (
          <>
            {bookingDate ? (
              <button onClick={handleSchedule} className="button-dark">
                Reschedule
              </button>
            ) : (
              <button onClick={handleSchedule} className="button-dark">
                Schedule
              </button>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default StepTwo;
